import { getPopularEnglishCerts } from './certificatesConstants';
const mapToCertificate = (track, awards) => {
  const award = awards[track.id];
  return Object.assign({
    id: parseInt(track.id, 10),
    // needs review as it is not really a number
    name: track.name,
    description: track.description
  }, award ? {
    isCompleted: true,
    isExpired: award.isExpired,
    expiresAt: award.expiresAt
  } : {});
};
export const getMostPopularCertsInEnglish = (tracks, awards) => {
  const popularEnglishTracks = [];
  const popularEnglishCerts = getPopularEnglishCerts();
  if (popularEnglishCerts) {
    popularEnglishCerts.forEach(certTrackId => {
      const track = tracks[certTrackId];
      if (track) {
        popularEnglishTracks.push(mapToCertificate(track, awards));
      }
    });
  }
  return popularEnglishTracks;
};
export const getAllCertsByLanguage = (lang, tracks, awards) => {
  return Object.values(tracks).filter(track => track.certification && track.language === lang).map(track => mapToCertificate(track, awards));
};